/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { useUserSubscriptions } from "./hooks";
import { dispatch, IUserSubscriptionModel, PaymentStore } from "@nf/common";
import {
  ActiveSubscriptionsContainer,
  PaymentFormProvider,
} from "./components";
import dynamic from "next/dynamic";

const NoSubscriptionsContainer = dynamic(
  () => import("components/Settings/NoSubscriptionContainer")
);

import { CommonTextError } from "../../CommonTextError";
import { useEffect } from "react";

export const SettingsSubscription = (): JSX.Element => {
  const { hasActiveSubscriptions, subscriptions, error } =
    useUserSubscriptions();

  useEffect(() => {
    dispatch(PaymentStore.Actions.getOffers());
  }, []);

  return (
    <PaymentFormProvider>
      <>
        {hasActiveSubscriptions && !error && (
          <ActiveSubscriptionsContainer
            subscriptions={subscriptions as IUserSubscriptionModel[]}
          />
        )}

        {!hasActiveSubscriptions && !error && <NoSubscriptionsContainer />}

        {error && <CommonTextError translationKey="web_my_account_error" />}

        <div id="portal"></div>
      </>
    </PaymentFormProvider>
  );
};

export default SettingsSubscription;
